import React, { Fragment, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  CustomInput,
} from "reactstrap";
import Loader from "react-loaders";
import { api } from "../../_services/api.service";
import Slider from "rc-slider";
import PageTitle from "../../Layout/AppMain/PageTitle";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import AvField from "availity-reactstrap-validation/lib/AvField";
import { toast } from "react-toastify";
import swal from "sweetalert";

const CriteriaSettings = ({
  partnerObjectiveId,
  partnerScenarioId,
  partnerScenario,
  partnerId,
  showMainModal,
  toggleMainModal,
  reloadList,
}) => {
  const sliderRanges = [
    {
      min: 0,
      max: 0.01,
      text: "Not at all!",
    },
    {
      min: 0.01,
      max: 0.375,
      text: "Very Bad",
    },
    {
      min: 0.375,
      max: 0.75,
      text: "Bad",
    },
    {
      min: 0.75,
      max: 1.125,
      text: "Pretty Bad",
    },
    {
      min: 1.125,
      max: 1.5,
      text: "OK",
    },
    {
      min: 1.5,
      max: 1.875,
      text: "Pretty good",
    },
    {
      min: 1.875,
      max: 2.25,
      text: "Very good",
    },
    {
      min: 2.25,
      max: 2.625,
      text: "Really good!",
    },
    {
      min: 2.625,
      max: 3,
      text: "Perfect!",
    },
  ];

  let defaultObjective = {
    partnerObjectiveID: -1,
    partnerScenarioID: partnerScenarioId,
    partnerMetricID: 0,
    partnerObjectiveName: "",
    partnerObjectiveType: "",
    description: "",
    linkedToMetric: false,
    provideAutomatedRating: false,
    provideManualRating: false,
  };

  let [objective, setObjective] = useState(defaultObjective);
  let [isLoading, setIsLoading] = useState(false);
  let [alternatives, setAlternatives] = useState([]);
  let [ratings, setRatings] = useState([]);
  let [metrics, setMetrics] = useState([]);
  let [showModal, setShowModal] = useState(false);
  let [ratingToEdit, setRatingToEdit] = useState(null);

  const successToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.SUCCESS,
    hideProgressBar: false,
  };

  useEffect(() => {
    if (showMainModal && partnerObjectiveId > -1) {
      loadMetrics();
      loadObjective(partnerObjectiveId);
    } else if (showMainModal) {
      loadMetrics();
      setObjective(defaultObjective);
    }
  }, [showMainModal, partnerObjectiveId]);

  const loadObjective = (id) => {
    if (id > 0) {
      setIsLoading(true);
      api.getPartnerObjectiveById(id).then((data) => {
        if (data.partnerMetricID > 0) {
          data.linkedToMetric = true;
        }

        setObjective(data);
        loadAlternatives(data.partnerObjectiveID);
        setIsLoading(false);
      });
    }
  };

  const loadMetrics = () => {
    api.getPartnerMetricsByPartnerScenario(partnerScenarioId).then((data) => {
      setMetrics(data);
    });
  };

  const loadAlternatives = (partnerObjId) => {
    api
      .getPartnerAlternativesByPartnerScenarioId(partnerScenarioId)
      .then((data) => {
        api
          .getPartnerAlternativeRatingsByPartnerObjective(partnerObjId)
          .then((ratings) => {
            setAlternatives(data);
            setRatings(ratings);
          });
      });
    // api.getPartnerMetricsByPartnerScenario(partnerScenarioId).then(data => {
    //     setMetrics(data);
    // })
  };

  const handleSubmit = (e, errors, values) => {
    if (errors.length == 0) {
      if (objective.partnerObjectiveID > 0) {
        api.updatePartnerObjective(0, objective).then((data) => {
          toast(
            `${
                partnerScenario.ahpOnly ? "Alternative" : "Criteria"
            } saved successfuly`,
            successToastOpts
          );
          toggleMainModal();
          reloadList();
        });
      } else {
        let o = { ...objective, partnerScenarioID: partnerScenarioId };
        api.createPartnerObjective(0, o).then((id) => {
          toast(
            `${
                partnerScenario.ahpOnly ? "Alternative" : "Criteria"
            } saved successfuly`,
            successToastOpts
          );
          toggleMainModal();
          reloadList();
        });
      }
    }
  };

  const saveCriteriaAndAddAnother = (e, errors, values) => {
    if (objective.partnerObjectiveID > 0) {
      api.updatePartnerObjective(0, objective).then((data) => {
        toast(
          `${partnerScenario.ahpOnly ? "Alternative" : "Criteria"} saved successfuly`,
          successToastOpts
        );
        reloadList();
        setObjective({ ...defaultObjective });
        setAlternatives([]);
        setRatings([]);
      });
    } else {
      let o = { ...objective, partnerScenarioID: partnerScenarioId };
      api.createPartnerObjective(0, objective).then((id) => {
        toast(
          `${partnerScenario.ahpOnly ? "Alternative" : "Criteria"} saved successfuly`,
          successToastOpts
        );
        reloadList();
        setObjective({ ...defaultObjective });
        setAlternatives([]);
        setRatings([]);
      });
    }
  };

  const getRatingValue = (partnerAlternativeId, prop) => {
    let rating = ratings.find(
      (x) => x.partnerAlternativeID == partnerAlternativeId
    );
    return rating == undefined ? "" : rating[prop];
  };

  const removeObjective = () => {
    swal({
      text: `Are you sure you want to remove this ${
        partnerScenario.ahpOnly ? "alternative" : "criteria"
      }?`,
      icon: "warning",
      buttons: {
        ok: "Yes",
        cancel: "No",
      },
      dangerMode: true,
    }).then((val) => {
      if (val) {
        api.deletePartnerObjective(0, objective).then((data) => {
          //props.history.goBack();
          toggleMainModal();
          reloadList();
        });
      }
    });
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleRatingSubmit = (e, errors, values) => {
    if (errors.length == 0) {
      if (ratingToEdit.partnerAltObjRatingID > 0) {
        api.updatePartnerAlternativeRating(ratingToEdit).then((data) => {
          toggleModal();
          loadObjective(partnerObjectiveId);
        });
      } else {
        api.createPartnerAlternativeRating(ratingToEdit).then((data) => {
          toggleModal();
          loadObjective(partnerObjectiveId);
        });
      }
    }
  };

  const handleLinkedToMetricChanged = () => {
    setObjective({
      ...objective,
      linkedToMetric: !objective.linkedToMetric,
      partnerMetricID: !objective.linkedToMetric
        ? metrics[0].partnerMetricID
        : 0,
    });
  };

  const editRating = (alternative) => {
    let rating = ratings.find(
      (x) => x.partnerAlternativeID == alternative.partnerAlternativeID
    );
    if (rating == undefined) {
      let obj = {
        partnerAltObjRatingID: -1,
        partnerAlternativeID: alternative.partnerAlternativeID,
        partnerObjectiveID: objective.partnerObjectiveID,
        rating: 0,
        ratingReason: "",
      };
      setRatingToEdit(obj);
    } else {
      setRatingToEdit(rating);
    }
    toggleModal();
  };

  const getRange = (alt) => {
    var r = sliderRanges.find(
      (x) => x.min <= alt.rating && x.max >= alt.rating
    );
    return r == undefined ? "" : r.text;
  };

  return (
    <Modal
      size="lg"
      isOpen={showMainModal}
      toggle={() => toggleMainModal()}
      backdrop="static"
    >
      <ModalHeader toggle={() => toggleMainModal()}>
        {partnerScenario.ahpOnly ? "Alternative" : "Criteria"}
      </ModalHeader>
      <ModalBody>
        {isLoading && <Loader style={{}} type="ball-pulse" active />}
        {!isLoading && (
          <Row style={{ marginTop: "30px" }}>
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <AvForm onSubmit={handleSubmit}>
                    <Row>
                      <Col md="12">
                        <AvField
                          name="criteria"
                          label={`${
                            partnerScenario.ahpOnly ? "Alternative" : "Criteria"
                          } Name *`}
                          value={objective.partnerObjectiveName}
                          onChange={(e) =>
                            setObjective({
                              ...objective,
                              partnerObjectiveName: e.target.value,
                            })
                          }
                          placeholder="Enter..."
                        />
                        <AvField
                          name="desc"
                          label="Description"
                          value={objective.description}
                          type="textarea"
                          style={{ height: "100px" }}
                          onChange={(e) =>
                            setObjective({
                              ...objective,
                              description: e.target.value,
                            })
                          }
                          placeholder="Enter..."
                        />

                        {metrics.length > 0 && (
                          <Fragment>
                            <div className="form-group">
                              <CustomInput
                                type="checkbox"
                                id="linkedToMetric"
                                checked={objective.linkedToMetric}
                                label="This Criterion is tied to a data-item"
                                onChange={(e) => handleLinkedToMetricChanged()}
                              />
                              <div className="notes">
                                Linking the criteria to a data-item allows you
                                to indicate that there is data provided with an
                                alternative that should be taken into account
                                for this criteria. (If you are not providing
                                alternatives with this template this shuld not
                                be checked)
                              </div>
                            </div>

                            {objective.linkedToMetric && (
                              <div className="form-group">
                                <CustomInput
                                  type="select"
                                  value={objective.partnerMetricID}
                                  className="form-control"
                                  name={"metric"}
                                  onChange={(e) => {
                                    setObjective({
                                      ...objective,
                                      partnerMetricID: parseInt(e.target.value),
                                    });
                                  }}
                                >
                                  {metrics.map((m) => {
                                    return (
                                      <option
                                        key={m.partnerMetricID}
                                        value={m.partnerMetricID}
                                      >
                                        {m.partnerMetricName}
                                      </option>
                                    );
                                  })}
                                </CustomInput>
                              </div>
                            )}
                          </Fragment>
                        )}

                        <br />
                        {!partnerScenario.ahpOnly && (
                          <div className="form-group">
                            <CustomInput
                              type="checkbox"
                              id="manual"
                              checked={objective.provideManualRating}
                              label="Provide suggested Rating Manually"
                              onChange={(e) =>
                                setObjective({
                                  ...objective,
                                  provideManualRating: !objective.provideManualRating,
                                })
                              }
                            />
                            <div className="notes">
                              Provide a suggest rating manually allows you to
                              suggest a rating for this criteria in each of the
                              alternatives you provide. These suggestions are
                              shown to the decision maker when he/she is scoring
                              the alternatives.
                            </div>
                          </div>
                        )}

                        <br />
                        <div className="form-group">
                          <CustomInput
                            type="checkbox"
                            id="musthave"
                            checked={objective.mustHave}
                            label="Cannot be removed by decision maker"
                            onChange={(e) =>
                              setObjective({
                                ...objective,
                                mustHave: !objective.mustHave,
                              })
                            }
                          />
                          <div className="notes">
                            By default, criteria that you suggest in template
                            can be removed by the decision maker. If you want to
                            make a criterion mandatory, check the "Cannot be
                            removed by decision maker" checkbox.
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className="pull-right">
                      <Button
                        color="primary"
                        type="submit"
                        style={{ marginRight: ".25rem" }}
                      >
                        Save
                      </Button>
                      <Button
                        color="primary"
                        style={{ marginRight: ".25rem" }}
                        onClick={() => saveCriteriaAndAddAnother()}
                      >
                        Save and Add Another
                      </Button>
                      {objective.partnerObjectiveID > 0 && (
                        <Button
                          color="danger"
                          onClick={() => removeObjective()}
                        >
                          Delete
                        </Button>
                      )}
                      <Button
                        color="link"
                        className="pull-right"
                        onClick={() => toggleMainModal()}
                      >
                        Cancel
                      </Button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {!partnerScenario.ahpOnly && objective.partnerObjectiveID > 0 && alternatives.length > 0 && (
          <Row style={{ marginTop: "30px" }}>
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <div className="h3">Rating Suggestions</div>
                  <table className="table-responsive" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th width="30%">Alternative</th>
                        <th width="30%">Suggested Rating</th>
                        <th width="30%">Reason</th>
                        <th width="10%" />
                      </tr>
                    </thead>
                    <tbody>
                      {alternatives.map((m) => {
                        return (
                          <tr key={m.partnerAlternativeID}>
                            <td>{m.partnerAlternativeName}</td>
                            <td>
                              {getRatingValue(m.partnerAlternativeID, "rating")}
                            </td>
                            <td>
                              {getRatingValue(
                                m.partnerAlternativeID,
                                "ratingReason"
                              )}
                            </td>
                            <td>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  editRating(m);
                                }}
                              >
                                Change
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </ModalBody>
      <Modal
        size="md"
        isOpen={showModal}
        toggle={() => toggleModal()}
        backdrop="static"
      >
        {ratingToEdit !== null && (
          <Fragment>
            <ModalHeader toggle={() => toggleModal()}>
              {
                alternatives.find(
                  (x) =>
                    x.partnerAlternativeID == ratingToEdit.partnerAlternativeID
                ).partnerAlternativeName
              }
            </ModalHeader>
            <ModalBody>
              <AvForm onSubmit={handleRatingSubmit}>
                <Row>
                  <Col md="12">
                    <div className="form-group">
                      <label>Rating</label>

                      <div style={{ width: "100%", height: "30px" }}>
                        <i
                          className="fa fa-frown"
                          style={{
                            float: "left",
                            color: "red",
                            fontSize: "16px",
                          }}
                        />
                        <i
                          className="fa fa-smile"
                          style={{
                            float: "right",
                            color: "green",
                            fontSize: "16px",
                          }}
                        />
                      </div>

                      <Slider
                        style={{ marginLeft: "10px" }}
                        min={0}
                        max={3}
                        defaultValue={ratingToEdit.rating}
                        step={0.1}
                        onChange={(val) =>
                          setRatingToEdit({ ...ratingToEdit, rating: val })
                        }
                      />
                      <p
                        style={{ fontSize: 12, margin: 0, textAlign: "center" }}
                      >
                        {getRange(ratingToEdit)}
                      </p>
                    </div>

                    <AvField
                      name="reason"
                      label="Reason"
                      value={ratingToEdit.ratingReason}
                      type="textarea"
                      onChange={(e) =>
                        setRatingToEdit({
                          ...ratingToEdit,
                          ratingReason: e.target.value,
                        })
                      }
                      placeholder="Value..."
                    />
                  </Col>
                </Row>
                <Button color="link" onClick={() => toggleModal()}>
                  Cancel
                </Button>
                <Button
                  color="primary"
                  type="submit"
                  style={{ marginLeft: ".25rem" }}
                >
                  Save
                </Button>{" "}
              </AvForm>
            </ModalBody>
          </Fragment>
        )}
      </Modal>
    </Modal>
  );
};

export default CriteriaSettings;
